import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { EmployeesState } from "@reducers/types/HRM/employees-state";

import { getEmployeesRequest } from "@actions/HRM/employees/employees-actions";
import { getEmployeesState } from "@selectors/HRM/employees/employees-selector";

import { useAppSelector } from "@helpers/redux";

import { EmployeeType, EmployeesResponseType } from "@type/HRM/employees";
import { PaginationType, PaginationRequestType } from "@type/HRM/pagination";

interface UseSeniors {
  employeeRequest: boolean;
  employeeSuccess: boolean;
  employeeFailed: boolean;
  employees: EmployeeType[];
  pagination: PaginationType;
  handleQuery: (key: string, value: number | string) => void;
  handleOrder: (key: string) => void;
  queryParams: StateType;
}
interface StateType extends PaginationRequestType {
  gradeOrder: string | null;
  promotionOrder: string | null;
  joiningDateOrder: string | null;
}

export const useTransferCandidates = (): UseSeniors => {
  const [query, setQuery] = useState<StateType>({
    page: 1,
    size: 10,
    search: "",
    gradeOrder: null,
    promotionOrder: null,
    joiningDateOrder: null,
    flowStatusId: 87,
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const handleOrder = (key: string) => {
    return setQuery((prev) => {
      let queryValue = null;
      switch (prev[key]) {
        case null:
          queryValue = "ASC";
          break;
        case "ASC":
          queryValue = "DESC";
          break;
        default:
          queryValue = null;
          break;
      }
      return {
        ...prev,
        [key]: queryValue,
      };
    });
  };

  const getEmployees = useAppSelector<EmployeesState>(getEmployeesState);

  const employeeRequest = getEmployees.request as boolean;
  const employeeSuccess = getEmployees.success as boolean;
  const employeeFailed = getEmployees.failed as boolean;
  const { data: employees, pagination } = getEmployees.data
    ? getEmployees.data
    : ({} as EmployeesResponseType);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployeesRequest(query));
  }, [dispatch, query]);

  return {
    employeeRequest,
    employeeSuccess,
    employeeFailed,
    employees,
    pagination,
    queryParams: query,
    handleQuery,
    handleOrder,
  };
};
